import { KeyWrapper } from './KeyWrapper';
import { Keyboard, KeyboardWrapperProps } from './Keyboard';

export function KeyboardWrapper(props: KeyboardWrapperProps) {
  return <Keyboard {...props} keyComponent={KeyWrapper} />;
}
